export const DEFAULT_SEO_IMAGE =
  'https://www.xing.com/img/n/xing_icon_apple.png';
export const DEFAULT_ICON =
  'https://www.xing.com/assets/frontend_minified/img/shared/xing_r1.ico';
export const DEFAULT_APPLE_ICON =
  'https://www.xing.com/assets/frontend_minified/img/shared/xing_icon_apple.png';
